var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.51,
    height: 19.501,
    viewBox: "0 0 19.51 19.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#007a7a;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(661.75 174.517)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-642.991-165.575v4.33H-661v-4.33",
    transform: "translate(0 5.478)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 14.118,
    transform: "translate(-651.995 -174.517)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-648.295-168.46l-5.028,5.028-5.028-5.028",
    transform: "translate(1.327 3.033)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.a7e552197fa85b08c413045c7dda0e20.svg";
export { ForwardRef as ReactComponent };